import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import PlanDetails from "./details/plan/plan-details.component";
import FeatureDetails from "./details/feature/feature-details.component";
import RateDetails from "./details/rate/rate-details.component";
export class RateCatalogue extends Component {
    constructor(props) {
        super(props);
        this.state={
            viewDetailPage:false,
            listSelected:"Plan",
            tabSelected:0,
            selectedIndex: 0,
        }
    }

    getData=(value)=>{
        this.setState({viewDetailPage:value})
    }
    
    filterList=(value)=>{
        this.setState({listSelected:value})
    }

    tabSelected=(value)=>{
        this.setState({tabSelected:value})
    }

    FilterIndex=(value)=>{
        this.setState({selectedIndex:value})
    }

    render() {
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: [
                    {
                        name: "Contract Name"
                    },
                    {
                        name: "Vendor"
                    }, {
                        name: "Status"
                    }, {
                        name: "Service Type"
                    }, {
                        name: "Effective Date"
                    }, {
                        name: "Expiration Date"
                    }
                ],
                dataItem: [{
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }
                ]

            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
    
        const filtersub=[
            {key:31,
            value:"Change Location Address"},
            {key:5,value:"Change Price Plan"},
            {key:4,value:"Change User"},
            {key:14,value:"Change Vendor"},
            {key:29,value:"Change Vendor"},
            {key:27,value:"New Circuit"},
            {key:9,value:"New Mobile Subscription"},
            {key:32,value:"Other"}];

        const filterData = [
            {
                id:1,
                filterTitle:"Item 1",
                
            },
            {
                id:2,
                filterTitle:"Item 2",              
            },
            {
                id:3,
                filterTitle:"Item 3",              
            }, {       
                id:4,        
                filterTitle:"Item 4 with Checkbox",              
            }
        ];        

        const listItem={
            Tab:[
                {
                    "id":"0",
                    "label":"Plan"            
                },
                {
                    "id":"1",
                    "label":"Feature"           
                },
                {
                    "id":"2",
                    "label":"Rate"           
                },
            ]
        };
 
        return (
            <>
                <RequestHeaders headerTitle="Rate Catalogue" />
                {
                    this.state.viewDetailPage && this.state.listSelected==="Plan" &&
                    <PlanDetails closeForm={this.getData.bind(this)} />
                }
                {
                    this.state.viewDetailPage && this.state.listSelected==="Feature" &&
                    <FeatureDetails closeForm={this.getData.bind(this)} />
                }
                {
                    this.state.viewDetailPage && this.state.listSelected==="Rate" &&
                    <RateDetails closeForm={this.getData.bind(this)} />
                }               
                {!this.state.viewDetailPage &&
                                     
                    <div className="request-table data-table internal-data-table">
                        <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} enableFilterBtn={true} filterData={filterData} 
                        filtersub={filtersub}  btnAddTitle={`Add ${this.state.listSelected}`} 
                        listSelected={this.state.listSelected} enableAddBtn={true} listItem={listItem.Tab} 
                        filterList={this.filterList} selectedIndex={this.state.selectedIndex}
                        FilterIndex={this.FilterIndex} haveTab={true} />

                            {dataTable.map((item, id) =>
                                <DataTable key={id} id={id} item={item} header={item.HeaderItem} getData={this.getData} data={item.dataItem} customClassName="table-container" pages={pages} isDataLoaded={true} havePagination={true} />
                            )}
                    </div>

                }
                                
            </>
        )
    }
}